/* eslint-disable indent */
import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { GridBlock } from '../../Support/Html/Components';

const SiteInfo = ({ classes, site, totalTrucks, trucksArrived }) => {
  return (
    <Grid container spacing={1}>
      <GridBlock xs={12}>
        <Typography variant="h6">{site.address}</Typography>
      </GridBlock>
      <GridBlock xs={12} className={classes.truckList}>
        <Typography variant="body2" className={classes.greyDetails}>
          Trucks arrived
        </Typography>
      </GridBlock>
      <GridBlock xs={12} className={classes.truckList}>
        <Typography variant="body1" className={classes.truckRow}>
          {trucksArrived || `0`} of {totalTrucks}
        </Typography>
      </GridBlock>
    </Grid>
  );
};

export default SiteInfo;
